'use client';

import classNames from 'classnames/bind';
import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import {
  APPEAL_TRANSLATIONS,
  TRANSLATION_NAMESPACE,
} from '@/_constants/translations';
import { EFormTabId } from './_types';
import styles from './index.module.scss';

const BLOCK_NAME = 'FormTabs';
const cn = classNames.bind(styles);

export const FormTabs = () => {
  const t = useTranslations(TRANSLATION_NAMESPACE);

  const tabs = useMemo(
    () => [
      {
        id: EFormTabId.MainInfo,
        text: t(APPEAL_TRANSLATIONS.newAppeal.tabs.mainInfo),
        disabled: false,
      },
      {
        id: EFormTabId.SellerAndProducts,
        text: t(APPEAL_TRANSLATIONS.newAppeal.tabs.sellerAndProducts),
        disabled: true,
      },
      {
        id: EFormTabId.Documents,
        text: t(APPEAL_TRANSLATIONS.newAppeal.tabs.documents),
        disabled: true,
      },
    ],
    [t],
  );

  return (
    <ul className={cn(BLOCK_NAME)}>
      {tabs.map((item) => (
        <li
          className={cn(`${BLOCK_NAME}__tab`, {
            [`${BLOCK_NAME}__tab--disabled`]: item.disabled,
          })}
          key={item.id}
        >
          {item.text}
        </li>
      ))}
    </ul>
  );
};
